import { render, staticRenderFns } from "./AppointmentUpdatedToAssistant.vue?vue&type=template&id=4edebfec"
import script from "./AppointmentUpdatedToAssistant.vue?vue&type=script&lang=js"
export * from "./AppointmentUpdatedToAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports